export const SUPPORT_TOPIC = {
  FEATURE_REQUEST: 'feature_request',
  REPORT_A_BUG: 'report_a_bug',
  REPORT_AN_ISSUE: 'report_an_issue',
  QUESTION_OR_HOW_TO: 'question_or_how_to',
  OTHER: 'other',
}

export const SUPPORT_TOPICS = [
  {
    value: SUPPORT_TOPIC.QUESTION_OR_HOW_TO,
    label: 'I have a question',
  },
  {
    value: SUPPORT_TOPIC.REPORT_AN_ISSUE,
    label: 'Report an issue',
  },
  {
    value: SUPPORT_TOPIC.REPORT_A_BUG,
    label: 'Report a bug',
  },
  {
    value: SUPPORT_TOPIC.FEATURE_REQUEST,
    label: 'Request a feature',
  },
  {
    value: SUPPORT_TOPIC.OTHER,
    label: 'Something else',
  },
]

export const EMPTY_SUPPORT_FORM = {
  topic: '',
  message: '',
}

export function buildScanFailedSupportMessage(errorText) {
  const base = 'Hi, my website scan failed and I need help resolving this.'
  return errorText
    ? `${base}\n\nError: ${errorText}\n\nWhat can I do to fix it?`
    : `${base}\n\nWhat can I do to fix it?`
}
